module.exports = __webpack_public_path__ + "img/subheader01_bottom.6f51db0f.jpg";